import {getWorkspaceFromUri, urlBuilder} from '@dms/routes';

import type {Nullish} from 'shared/web';

import {createSearchParamsString} from './createSearchParamsString';

interface GetOnlineOfferUriParams {
  offerId: string | Nullish;
  language: string;
  sellerEmail: string | Nullish;
  includeOpenedBy?: boolean;
}

const {workspace} = getWorkspaceFromUri();

export function getOnlineOfferUri(params: GetOnlineOfferUriParams) {
  return urlBuilder({
    workspace,
    protocol: window.location.protocol,
    domain: process.env.ONLINE_OFFER_DOMAIN!,
    route: `/${params.offerId}`,
    searchParam: createSearchParamsString({
      lang: params.language,
      sellerEmail: params.sellerEmail ?? undefined,
      openedBy: params.includeOpenedBy === false ? undefined : 'email',
    }),
  });
}
